import React from 'react'
import DayPicker from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import './../assets/style.css'

class CalendarContentComponent extends React.Component {
  disabledDays (day) {
    let now = new Date()
    now.setHours(12, 0, 0, 0)
    
    // Désactiver les dates futures
    if (day > now) {
      return true
    }
    
    // Désactiver les dates qui ne sont pas dans dateList
    if (this.props.dateList && this.props.dateList.length > 0) {
      const dayTimestamp = new Date(day).setHours(0, 0, 0, 0)
      const isInDateList = this.props.dateList.some(date => {
        const dateTimestamp = new Date(date).setHours(0, 0, 0, 0)
        return dateTimestamp === dayTimestamp
      })
      return !isInDateList
    }
    
    return false
  }

  handleDayClick = (day, modifiers) => {
    // Empêcher le clic sur les jours désactivés
    if (modifiers.disabled) {
      return
    }
    this.props.handleDayClick(day, modifiers)
  }

  render () {
    const modifiers = {
      myDay: this.props.dateList
    }
    const modifiersStyles = {
      myDay: {
        color: '#FFFFFF'
      },
      disabled: {
        color: '#000000'
      },
      selected: {
        backgroundColor: '#417505',
        outline: 'none'
      }
    }
    return (
      <div style={styles.paper}>
        <div style={styles.content}>
          <DayPicker
            initialMonth={this.props.initialMonth}
            onMonthChange={(month) => this.props.onMonthChange(month)}
            onDayClick={this.handleDayClick}
            selectedDays={this.props.selectedDay}
            disabledDays={(day) => this.disabledDays(day)}
            modifiers={modifiers}
            modifiersStyles={modifiersStyles}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    height: '300px'
  },
  content: {
    width: '100%',
    height: 'auto'
  }
}

export default CalendarContentComponent
